<template>
  <layout v-bind="layoutProps" v-on="$listeners">
    <bb-datepicker
      name="date"
      type="date"
      :minDate="dateIntervalSettings.minDate"
      :maxDate="dateIntervalSettings.maxDate"
      :shortcuts="false"
      v-model="form.date"
      :label="translations.date"
      :data-vv-as="translations.date"
      :format="dateFormat"
      :lang="datepickerLanguage"
      v-validate="'required'"
    />
    <bb-textarea
      name="description"
      v-model="form.description"
      :label="translations.description"
      :data-vv-as="translations.description"
      rows="5"
      maxlength="1000"
      v-validate="'required'"
    />
  </layout>
</template>

<script>
import Layout from './Layout.vue'
import { getDateFormat, formatDateForRequest } from '@/plugins/dateFormatters'
import { mapState } from 'pinia'
import dayjs from 'dayjs'
import { LOAN_PREMATURE_FULLFILLMENT_MAX_DAYS, LOAN_PREMATURE_FULLFILLMENT_MIN_DAYS } from '@/const'
import { CountryChannel } from '@bigbank/dc-common/config'
import { useRootStore } from '../../../../store/root'

export default {
  components: { Layout },
  name: 'manage-loan-premature-fulfillment',
  data () {
    return {
      dateFormat: getDateFormat(),
      form: {
        description: undefined,
        date: undefined
      }
    }
  },
  props: {
    showLoader: {
      required: true
    }
  },
  computed: {
    ...mapState(useRootStore, ['datepickerLanguage', 'channel', 'isCompany']),
    dateIntervalSettings () {
      return {
        minDate: dayjs().add(LOAN_PREMATURE_FULLFILLMENT_MIN_DAYS, 'days').toDate(),
        maxDate: this.isCompany ? undefined : dayjs().add(LOAN_PREMATURE_FULLFILLMENT_MAX_DAYS, 'days').toDate()
      }
    },
    translations () {
      return {
        title: this.$pgettext('manage_loan_premature_fulfillment', 'Apply for premature fulfilment contract change'),
        text: this.isCompany ? this.prematureFulfillmentCorporateText : this.prematureFulfillmentText,
        buttonText: this.$pgettext('manage_loan_premature_fulfillment', 'Continue'),
        description: this.$pgettext('manage_loan_premature_fulfillment', 'Description'),
        date: this.$pgettext('manage_loan_premature_fulfillment', 'Choose the date you wish to pay')
      }
    },
    prematureFulfillmentText () {
      return this.channel === CountryChannel.LV
        ? this.$pgettext('manage_loan_premature_fulfillment_lv',
          'If You wish to repay your contract prematurely, please contact us via phone or email, so that we could calculate the exact sum needed to be paid')
        : this.$pgettext('manage_loan_premature_fulfillment',
          'If You wish to repay your contract prematurely, please contact us via phone or email, so that we could calculate the exact sum needed to be paid')
    },
    prematureFulfillmentCorporateText () {
      return this.channel === CountryChannel.LV
        ? this.$pgettext('corporate-manage-loan_premature-fulfillment_lv',
          'If You wish to repay your contract prematurely, please contact us via phone or email, so that we could calculate the exact sum needed to be paid')
        : this.$pgettext('corporate-manage-loan_premature-fulfillment',
          'If You wish to repay your contract prematurely, please contact us via phone or email, so that we could calculate the exact sum needed to be paid')
    },
    layoutProps () {
      return {
        visible: true,
        title: this.translations.title,
        text: this.translations.text,
        buttonText: this.translations.buttonText,
        showLoader: this.showLoader,
        data: {
          ...this.form,
          date: formatDateForRequest(this.form.date)
        }
      }
    }
  }
}
</script>
